import {PreferencesState} from './types';

export const initialState: PreferencesState = {
  preferences: {
    enableCalendar: false,
    userClosedConsentTile: false,
    userClosedConsentErrorTile: false,
    workingHours: null,
    workspaceLocation: null,
    parkingLocation: null,
    userDismissedParkingSuggestionPopUp: true,
    userDismissedParkingIntroduction: true,
    licensePlate: null,
    licensePlates: null,
    calendarDomain: null,
    threeDMapsPreferred: true,
  },
  isInitialized: false,
  isLoading: false,
  isSaving: false,
  error: null,
};
